/*
 *
 * CostsCostsShopPickerPopup
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 02-Oct-2025
*/

import { connect } from 'react-redux'
import CostsShopPickerPopup from './CostsShopPickerPopup'
import { nullSafe } from 'Utility/globalMethods'
import { doSetCostsShopSelection, doClearCostsShopSelection, doGetCostsShopList, doSetShopSearchTerm, clearSearchTerm, doSetCostsShopLocalSelection, doClearCostsShopLocalSelection, doSetLocalSelectedTab } from 'Store/actions/shopPicker'
import { doHidePopup, doShowPopup } from 'Store/actions/popup'
import { doSetRefreshCostsContext } from '../../routes/Costs/modules/CostsActions'

const mapDispatchToProps = dispatch => ({
  // SOLO azioni specifiche per costs
  setCostsShopSelection: (payload) => dispatch(doSetCostsShopSelection(payload)),
  clearCostsShopSelection: (group, data) => dispatch(doClearCostsShopSelection(group, data)),
  doClosePopup: (type) => dispatch(doHidePopup(type)),
  doShowPopup: (type) => dispatch(doShowPopup(type)),
  doGetCostsShopList: (type) => dispatch(doGetCostsShopList(type)),
  doSetShopSearchTerm: (payload) => dispatch(doSetShopSearchTerm(payload)),
  clearSearchTerm: (payload) => dispatch(clearSearchTerm(payload)),
  doClearCostsShopLocalSelection: (payload) => dispatch(doClearCostsShopLocalSelection(payload)),
  doSetCostsShopLocalSelection: (payload) => dispatch(doSetCostsShopLocalSelection(payload)),
  doSetRefreshCostsContext: (payload) => dispatch(doSetRefreshCostsContext(payload)),
  doSetLocalSelectedTab: (payload) => dispatch(doSetLocalSelectedTab(payload))
})

const mapStateToProps = state => ({
  // Use costs-specific selector groups for costs context
  selectorGroups: nullSafe(() => state.userProfiling.selectorCostsGroups, []),
  shopSelections: nullSafe(() => state.shopPicker.group, []),
  shopSelectionFromPage: nullSafe(() => state.shopPicker.shopSelectionFromPage, 'default'),
  // Use costs-specific local selection for preselezioni
  shopLocalSelection: nullSafe(() => state.shopPicker.costsShopLocalSelection, {}),
  confirmedShopSelection: nullSafe(() => state.shopPicker.costsShopConfirmedSelection, {}),
  // Add additional props needed by CostsShopSelector
  shopListLoading: nullSafe(() => state.userProfiling.shopListCostsLoading, false),
  shopSearchTerm: nullSafe(() => state.shopPicker.searchTerm, ''),
  localSelectedTab: nullSafe(() => state.shopPicker.localSelectedTab, null)
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(CostsShopPickerPopup)
